import { FC } from 'react';
import MuiToolbar, { ToolbarProps } from '@mui/material/Toolbar';

export const Toolbar: FC<ToolbarProps> = props => <MuiToolbar {...props} />;
